
        const CLIENT_PRIORITY_CHIPS = [
            "Family safety",
            "Court appearance dates",
            "Media-facing event",
            "Business deal in flight",
            "Board meeting cycle",
            "Foreign travel",
            "Public speaking engagement",
            "Financial disclosures pending",
            "Children's school routine",
        ];

export { CLIENT_PRIORITY_CHIPS };
